<template>
  <app-page :title="`Batch #${batch?.batch_number || ''}`" subtitle="View details about this batch" icon="rotate">
    <div v-if="batch">
      <div class="batch-details">
        <p><strong>Status:</strong> {{ batch.status }}</p>
        <p><strong>Billing type:</strong> {{ batch.billing_type }}</p>
        <p><strong>Created at:</strong> {{ new Date(batch.created_at).toLocaleString() }}</p>
        <p>
          <strong>Submitted at:</strong>
          {{ batch.submitted_at ? new Date(batch.submitted_at).toLocaleString() : 'Not yet submitted' }}
        </p>
        <p><strong>Upload type:</strong> {{ batch.properties.upload_type }}</p>

        <div class="payments">
          <h3>Payments</h3>
          <div v-if="batch.payments.length !== 0">
            <b-table :items="batch.payments" :fields="FIELDS"></b-table>
          </div>
          <div v-else>No payments in this batch</div>
        </div>
      </div>
    </div>
    <div v-else>Loading...</div>
  </app-page>
</template>

<script setup>
import ApiClient from '@/ApiClient';
import { ref, onMounted } from 'vue';
import AppPage from '@/components/AppPage.vue';
import { useRoute } from 'vue-router/composables';
import { toCurrency } from '@/utils';

const batch = ref(null);
const route = useRoute();

onMounted(async () => {
  const batchId = route.params.batchId;
  if (batchId) {
    try {
      batch.value = (await ApiClient.getOffCyclePaymentBatch(batchId)).data;
    } catch (error) {
      console.error('Failed to fetch batch data:', error);
    }
  }
});

const FIELDS = [
  { key: 'employee_code', label: 'Employee Code' },
  { key: 'employee_email', label: 'Email' },
  { key: 'status', label: 'Status' },
  { key: 'payment_type', label: 'Reason' },
  { key: 'amount', label: 'Amount', formatter: value => toCurrency(value, 'USD') },
];
</script>

<style scoped>
.payment-item::marker {
  content: '';
}

.payments {
  margin-top: 3rem;
}
</style>
